import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styles from "./index.module.css";

const SkeletonCard = ({ fill }) => {
  const count = fill || 8;

  return (
    <>
      {Array(count)
        .fill()
        .map((_, index) => (
          <div className={styles.convetiSkeletonCard} key={index}>
            <Skeleton
              className={styles.convetiSkeletonImage}
              height="100%"
              width="100%"
            />
            <div className={styles.convetiSkeletonInfo}>
              <Skeleton height={14} width="72%" />
              <Skeleton height={16} width="38%" />
              <Skeleton height={10} width="52%" />
            </div>
          </div>
        ))}
    </>
  );
};

export default SkeletonCard;
